import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnswerWrongReason } from '../answer-wrong-feedback.model';
import { answerWrongReasonContent } from '../feedback-popup.content';
import { Assistants, Search } from '@local/client-contracts';

export type CheckedResource = Search.ResultResourceItem & { checked: boolean };

@Component({
  selector: 'feedback-reason-options',
  templateUrl: './feedback-reason-options.component.html',
  styleUrls: ['./feedback-reason-options.component.scss'],
})
export class FeedbackReasonOptionsComponent {
  answerWrongReasonContent: AnswerWrongReason = answerWrongReasonContent;
  @Input() option: { title: string; subtitle: string };
  @Input() resources: CheckedResource[];
  @Input() intent: Assistants.QuestionIntent;
  @Output() resourcesChecked = new EventEmitter<CheckedResource[]>();

  onClickResource(resource: CheckedResource) {
    resource.checked = !resource.checked;
  }

  sendCheckedResources(): void {
    const checkedResources = this.resources?.filter((resource) => resource.checked);
    this.resourcesChecked.emit(checkedResources);
  }
}
